$( document ).ready(function() {


  jQuery.extend(jQuery.easing, {
      easeInOutCirc: function (x, t, b, c, d) {
          if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
          return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
      },
  });
  function get_hash_val() {
      return window.location.hash.substr(1);
  }
  function do_animation(args) {
      jQuery('html, body').animate(args, 1000, 'easeInOutCirc');
  }
  function get_offset() {
      return 70;
  }
  function scroll_based_on_hash_val(el_prefix, ev) {
      var type = get_hash_val();
      if (type) {
          var end = (el_prefix + type);

          var args = {
              'scrollTop': 0
          };
          if (jQuery(end).length > 0) {
              args.scrollTop = jQuery(end).offset().top - get_offset();
              do_animation(args);
          }
      }
  }
  jQuery(window).load(function() {
      if(jQuery('.accessoriesSection').length !== 0) {
          setTimeout(function () {
              scroll_based_on_hash_val('.products--');
              jQuery(window).on('hashchange', scroll_based_on_hash_val.bind(null, '.products--'));
          }, 500);
      }
  });

  $('.prodSlider').slick({
      centerMode: true,
      infinite: true,
      variableWidth: true,
      slidesToShow: 1,
      centerPanning: '40px'
  });
  $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: '80px',
      focusOnSelect: true
  });
  $('.howMobileComp').slick({
      centerMode: false,
      infinite: true,
      variableWidth: true,
      slidesToShow: 1,
      dots:true,
      arrows: false,
      accessibility: false
  });
  $('.bigSlider').slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      swipeToSlide: true,
      swipe:true,
      touchMove:true,
      draggable:true,
      dots:false,
      arrows: false,
      accessibility: false
  });
  $('.mobileListSlider').slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false,
      accessibility: false
  });
  $('.mobileCompareSlider').slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false
  });
  $('.mobileYaleSlidShow').slick({
      centerMode: true,
      infinite: false,
      slidesToShow: 1,
      dots:false,
      arrows: false
  });
  $('.compareYaleSlideShow').slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false
  });
  $('.proSliderInner').slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false
  });
  $('.mobileQuoteSlider').slick({
      centerMode: true,
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false
  });
  
  $('.fDay__text').find('a').attr('target', '_blank');
  
  $('.bnbprod__slider').slick({
    arrows: true,
    dots: true,
    infinite: true
  });
  $('.bnbprod__mob').slick({
    arrows: false,
    dots: true,
    infinite: true
  });

  $("#dot1").find("img").addClass("activeDot");

  $('.bigSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var dot_selector = "#dot" + (nextSlide + 1);
      $(".mobileDotFlex").find(dot_selector).addClass("activeDot").attr("tabindex", "0");
      $(".mobileDotFlex li").removeClass("activeDot");
      $(".mobileDotFlex li" + dot_selector).addClass("activeDot");
      $(".customDotFlex").find("img").removeClass("activeDot");
      $(".customDotFlex").find(dot_selector).find("img").addClass("activeDot");
      $(".SliderText").html($(dot_selector).data("text"));
  });

  $(".customDotFlex").find("#dot1").click(function(event) {
      $( '.bigSlider' ).slick('slickGoTo', 0 );
      $(".dotBlock").find("img").removeClass("activeDot");
      $(this).find("img").addClass("activeDot");
      $(".SliderText").html($("#dot1").data("text"));
      $(event.target).closest('li').siblings().find('a').attr('aria-selected', 'false');
      $(event.target).closest('li').find('a').attr('aria-selected', 'true');
  });

  $(".customDotFlex").find("#dot2").click(function(event) {
      $( '.bigSlider' ).slick('slickGoTo', 1 );
      $(".dotBlock").find("img").removeClass("activeDot");
      $(this).find("img").addClass("activeDot");
      $(".SliderText").html($("#dot2").data("text"));
      $(event.target).closest('li').siblings().find('a').attr('aria-selected', 'false');
      $(event.target).closest('li').find('a').attr('aria-selected', 'true');
  });

  $(".customDotFlex").find("#dot3").click(function(event) {
      $( '.bigSlider' ).slick('slickGoTo', 2 );
      $(".dotBlock").find("img").removeClass("activeDot");
      $(this).find("img").addClass("activeDot");
      $(".SliderText").html($("#dot3").data("text"));

      $(event.target).closest('li').siblings().find('a').attr('aria-selected', 'false');
      $(event.target).closest('li').find('a').attr('aria-selected', 'true');
  });

  $(".customDotFlex").find("#dot3").on('keypress',function(e) {
      if(e.which == 13) {
          $( '.bigSlider' ).slick('slickGoTo', 2 );
          $(".dotBlock").find("img").removeClass("activeDot");
          $(this).find("img").addClass("activeDot");
          $(".SliderText").html($("#dot3").data("text"));
      }
  });

  $(".mobileIcons").find(".dotBlock").hide();
  $(".mobileIcons").find("#mobIcon1").show();
  $(".mobileDotFlex").find("#dot1").addClass("activeDot");

  $(".mobileDotFlex").find("#dot1").click(function() {
      $('.bigSlider').slick('slickGoTo', 0 );
      $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
      $(".SliderText").html($(this).data("text"));
      $(".mobileIcons").find(".dotBlock").hide();
      $(".mobileIcons").find("#mobIcon1").show();
  });

  $(".mobileDotFlex").find("#dot1").on('keypress',function(e) {
      if(e.which == 13) {
          $('.bigSlider').slick('slickGoTo', 0 );
          $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
          $(".SliderText").html($(this).data("text"));
          $(".mobileIcons").find(".dotBlock").hide();
          $(".mobileIcons").find("#mobIcon1").show();
      }
  });

  $(".mobileDotFlex").find("#dot2").click(function() {
      $('.bigSlider').slick('slickGoTo', 1 );
      $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
      $(".SliderText").html($(this).data("text"));
      $(".mobileIcons").find(".dotBlock").hide();
      $(".mobileIcons").find("#mobIcon2").show();
  });

  $(".mobileDotFlex").find("#dot2").on('keypress',function(e) {
      if(e.which == 13) {
          $('.bigSlider').slick('slickGoTo', 1 );
          $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
          $(".SliderText").html($(this).data("text"));
          $(".mobileIcons").find(".dotBlock").hide();
          $(".mobileIcons").find("#mobIcon2").show();
      }
  });

  $(".mobileDotFlex").find("#dot3").click(function() {
      $('.bigSlider').slick('slickGoTo', 2 );
      $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
      $(".SliderText").html($(this).data("text"));
      $(".mobileIcons").find(".dotBlock").hide();
      $(".mobileIcons").find("#mobIcon3").show();
  });

  $(".mobileDotFlex").find("#dot3").on('keypress',function(e) {
      if(e.which == 13) {
          $('.bigSlider').slick('slickGoTo', 2 );
          $(".mobileDotFlex").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
          $(".SliderText").html($(this).data("text"));
          $(".mobileIcons").find(".dotBlock").hide();
          $(".mobileIcons").find("#mobIcon3").show();
      }
  });

  $(".mobileListSlideDots").find("#listDot1").addClass("activeDot");

  $("#listDot1").click(function() {
      $('.mobileListSlider').slick('slickGoTo', 0 );
      $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
  });

  $("#listDot1").on('keypress',function(e) {
      if(e.which == 13) {
          $('.mobileListSlider').slick('slickGoTo', 0 );
          $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
      }
  });

  $("#listDot2").click(function() {
      $('.mobileListSlider').slick('slickGoTo', 1 );
      $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
  });

  $("#listDot2").on('keypress',function(e) {
      if(e.which == 13) {
          $('.mobileListSlider').slick('slickGoTo', 1 );
          $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
      }
  });

  $("#listDot3").click(function() {
      $('.mobileListSlider').slick('slickGoTo', 2 );
      $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
  });

  $("#listDot3").on('keypress',function(e) {
      if(e.which == 13) {
          $('.mobileListSlider').slick('slickGoTo', 2 );
          $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
      }
  });

  $("#listDot4").click(function() {
      $('.mobileListSlider').slick('slickGoTo', 3 );
      $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
      $(this).addClass("activeDot");
  });

  $("#listDot4").on('keypress',function(e) {
      if(e.which == 13) {
          $('.mobileListSlider').slick('slickGoTo', 3 );
          $(".mobileListSlideDots").find(".mobileDot").removeClass("activeDot");
          $(this).addClass("activeDot");
      }
  });

  $("#filterButton").hide();
  /*
  $(".worksFilter").find(".flex").slideUp();
  $(".worksFilter").find(".button").slideUp();
  $("#filterButton").click(function() {
    $(".worksFilter").find(".flex").slideToggle("fast");
    $(".worksFilter").find(".button").slideToggle("fast");
    if ($(this).attr("src") === "https://cdn.shopify.com/s/files/1/1354/7835/files/filterIcon.png?6982671539964481260"){
      $(this).attr("src", "https://cdn.shopify.com/s/files/1/1354/7835/files/Group_Copy_2.png?11086457333644568533");
    }
    else{
      $(this).attr("src", "https://cdn.shopify.com/s/files/1/1354/7835/files/filterIcon.png?6982671539964481260");
    }
  });*/

  $(".worksFilter").find(".flex").find(".block").click(function() {
      $(".worksFilter").find(".flex").find(".block").removeClass("active");
      $(this).addClass("active");
  });

  $(".worksFilter").find(".flex").find(".block").on('keypress',function(e) {
      if(e.which == 13) {
          $(".worksFilter").find(".flex").find(".block").removeClass("active");
          $(this).addClass("active");
      }
  });

  $(".worksFilter").find(".button").click(function() {
      $(".worksFilter").find(".flex").find(".block").removeClass("active");
  });

  $(".worksFilter").find(".button").on('keypress',function(e) {
      if(e.which == 13) {
          $(".worksFilter").find(".flex").find(".block").removeClass("active");
      }
  });
  
  
  $('.delDes__button--one').on('click', function(){
    $('.delDes__sled').attr('style', 'left:0%;');
    $('.delDes__button').removeClass('delDes__button--active');
    $(this).addClass('delDes__button--active');
  });
  
  $('.delDes__button--two').on('click', function(){
    $('.delDes__sled').attr('style', 'left:-100%;');
    $('.delDes__button').removeClass('delDes__button--active');
    $(this).addClass('delDes__button--active');
  });
  
  $('.delFaq__accTitle').on('click', function(e){
    e.preventDefault();
    var thisThing = $(this);
    var target = $(this).parent().find('.delFaq__content');
    if (target.is(':visible')){
      thisThing.removeClass('delFaq__accTitle--open');
      target.slideUp();
      thisThing.find( 'button' ).attr( 'aria-expanded', 'false' );
    }
    else{
      $('.delFaq__accTitle button').attr( 'aria-expanded', 'false' );
      $('.delFaq__accTitle').removeClass('delFaq__accTitle--open');
      $('.delFaq__content').slideUp();
      thisThing.find( 'button' ).attr( 'aria-expanded', 'true' );
      thisThing.addClass('delFaq__accTitle--open');
      target.slideDown();
    }
  });

  $('.delStep__slideshow').slick({
      infinite: false,
      slidesToShow: 1,
      dots:true,
      arrows: false
  });
  if ($(window).width() > 633) {
    $('.delStep__slideshow').hide();
  }


  function clickable(){
      $(".accordionTitle").click(function(){
          if (!$(this).parent().find(".accordionBody").is(':visible')){
              $(".accordionBody").slideUp();
              $(".accordionTitle").find(".exit").css("transform", "rotate(0deg)");
              $(".accordionTitle").find(".exit").css("filter", "none");
              $(this).parent().find(".accordionBody").slideDown();
              $(this).find(".exit").css("transform", "rotate(45deg) translate(7px, 7px)");
              $(this).find(".exit").css("filter", "sepia() saturate(10000%) hue-rotate(30deg)");
          }
          else{
              $(this).parent().find(".accordionBody").slideUp();
              $(this).find(".exit").css("transform", "rotate(0deg) translate(0px, 0px)");
              $(this).find(".exit").css("filter", "none");
          }
      });

      $(".accordionTitle").on('keypress',function(e) {
          if(e.which == 13) {
              if (!$(this).parent().find(".accordionBody").is(':visible')){
                  $(".accordionBody").slideUp();
                  $(".accordionTitle").find(".exit").css("transform", "rotate(0deg)");
                  $(".accordionTitle").find(".exit").css("filter", "none");
                  $(this).parent().find(".accordionBody").slideDown();
                  $(this).find(".exit").css("transform", "rotate(45deg) translate(7px, 7px)");
                  $(this).find(".exit").css("filter", "sepia() saturate(10000%) hue-rotate(30deg)");
              }
              else{
                  $(this).parent().find(".accordionBody").slideUp();
                  $(this).find(".exit").css("transform", "rotate(0deg) translate(0px, 0px)");
                  $(this).find(".exit").css("filter", "none");
              }
          }
      });

  }

  function getJobDetails(e){
      $.getJSON('https://boards-api.greenhouse.io/v1/boards/august50/jobs/' + jobsArray[i].id, function(data1){

          $(".item" + e).find(".title").html(data1.title);
          var content = data1.content;
          content.toString();
          content = content.replace(/&lt;/g , '<');
          content = content.replace(/&gt;/g , '>');

          $(".item" + e).find(".body").html(content);
          $(".item" + e).find("a").attr("href", data1.absolute_url );
      });
  }

  function jobTop(){
      $.getJSON('https://boards-api.greenhouse.io/v1/boards/august50/jobs',function(data){
          jobsArray = data.jobs;
          jobCounter = 0;
          for (i=0; i<jobsArray.length; i++){
              storageArray.push('<div class="accordionItem item' + i + '"><div class="accordionTitle"><span class="title"></span><span class="exit"><img src="https://cdn.shopify.com/s/files/1/1354/7835/files/plus.png?15781816615285918831"></span></div><div class="accordionBody"><span class="body"></span><a href="">Apply</a></div>');
              storageArray.toString();
              $("#accordion").html(storageArray);
              $(".accordionBody").hide();
              jobCounter = i;
              clickable();
              getJobDetails(jobCounter);
          }
      });
  }

  var jobsArray = [];
  var jobsHTML = [];
  var storageArray = [];
  var jobCounter = 0;

  $(function() {
      jobTop();

  });

  var pressBlocks = $(".pressSection").find(".block").slice(6);
  if ($(window).width() < 633) {
      $(pressBlocks).hide();
  }

  $(".pressSection").find(".more").click(function(){
      $(pressBlocks).slideDown();
      $(this).fadeOut();
  });

  $(".pressSection").find(".more").on('keypress',function(e) {
      if(e.which == 13) {
          $(pressBlocks).slideDown();
          $(this).fadeOut();
      }
  });

  var mobileBrandBlocks = $(".releasesFlex").find(".block").slice(6);
  var brandBlocks = $(".releasesFlex").find(".block").slice(18);
  if ($(window).width() < 633) {
      $(mobileBrandBlocks).hide();
  }
  else{
      $(brandBlocks).hide();
  }

  $(".brandSection").find(".more").click(function(){
      if ($(window).width() < 633) {
          $(mobileBrandBlocks).slideDown();
      }
      else{
          $(brandBlocks).slideDown();
      }
      $(this).fadeOut();
  });

  $(".brandSection").find(".more").on('keypress',function(e) {
      if(e.which == 13) {
          if ($(window).width() < 633) {
              $(mobileBrandBlocks).slideDown();
          }
          else{
              $(brandBlocks).slideDown();
          }
          $(this).fadeOut();
      }
  });


  $(".brandNav").find("a").on('click', function(event) {
      var hash = $(this).data("hash");
      if (hash) {
          $('html, body').animate({
              scrollTop: $(document.getElementById(hash)).offset().top
          }, 300, function() {
              window.location.hash = hash;
          });
      }
  });

  $(".brandNav").find("a").on('keypress',function(e) {
      if(e.which == 13) {
          var hash = $(this).data("hash");
          if (hash) {
              $('html, body').animate({
                  scrollTop: $(document.getElementById(hash)).offset().top
              }, 300, function() {
                  window.location.hash = hash;
              });
          }
      }
  });

  document.onkeyup = PresTab;

  function PresTab(e)
  {
      var keycode = (window.event) ? event.keyCode : e.keyCode;
      if (keycode == 9)
          $('body').addClass('tabbingOn');
  }

  
  var addListener = false;


  function a11yClick(event) {
      if (event.type === "click") {
          return true;
      } else if (event.type === "keypress") {
          var code = event.keyCode;
          if (code === 32 || code === 13) {
              return true;
          }
      } else {
          return false;
      }
  }

  $('.videoButtonOpen').on('click keypress', function (event){

      window.elBeforeModal = window.lastTabbableElement;

      if(a11yClick(event) === true){
          var vid = document.querySelector('.video-banner');
          var linkText = $(this).attr('data-href');
          if (window.videoIsPlaying) {
              vid.pause();
              window.videoIsPlaying = false;
              window.videoIsPaused = true;
          }

          console.log(  );

          $( '.main-content' ).attr( 'aria-hidden', 'true' );

          $("#videoModalContainer").html('<p style="position: relative; left: -10000px">popup content starts</p><iframe tabindex="0" width="560" height="315" src="https://www.youtube.com/embed/' + linkText + '?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe><p style="position: relative; left: 10000px">popup content ends</p>');
          if ( $( this ).data( 'transcript' ) !== undefined ) {
            $("#videoModalContainer").prepend( '<span class="sr-only" aria-label="Video Transcript">'+$( this ).data( 'transcript' )+'</span>' )
          }
          $("#videoModal").fadeIn();
          $("#videoModalContainer").focus().css("outline", "none");
          $('#videoModal').siblings().attr('aria-hidden', 'true');
          sleepless.accessibility.update_keep_focused();

          function escapeClicker() {
              if ( event.keyCode == 27 )   {
                  var $toEscape = $('[escape-to-click]');
                  $toEscape.click();
              }
          }

          document.querySelector('#videoModal iframe').contentDocument.addEventListener('keydown', escapeClicker);
          event.preventDefault();
      }
  });

  $(document).on('keydown', function(event) {
    if (event.key == "Escape") {
      
      // Close video modal
      if( $( '#videoModal' ).is(':visible') ) {
        $( '.videoButtonClose' ).click();
        $( '.main-content' ).attr( 'aria-hidden', 'false' );
      }

      // Close cart modal
      if( $( '.newCart' ).is(':visible') ) {
        $( '.newCart__close' ).click();
      }

      // Close compare modal
      if( $( '.compareModal' ).is(':visible') ) {
        $( '.closeCompare img' ).click();
        $( '.main-content' ).attr( 'aria-hidden', 'false' );
      }

      // Close klaivyo modal
      if( $( 'form[data-testid="klaviyo-form-V3vGs8"]' ).is(':visible') ) {
        $( 'button[class^="CloseButton"]' ).click();
      }

    }

  });

  $('.videoButtonClose').on('click keypress', function (event){
      if(a11yClick(event) === true){
          var vid = document.querySelector('.video-banner');
          if (window.videoIsPaused) {
              vid.play();
              window.videoIsPaused = false;
              window.videoIsPlaying = true;
          }
          $( '.main-content' ).attr( 'aria-hidden', 'false' );
          $("#videoModalContainer").html('');
          $("#videoModal").fadeOut();
          $('#videoModal').siblings().attr('aria-hidden', 'false');
          $('[aria-hidden="false"]').removeAttr('aria-hidden');
          $("[aria-hidden='false']").removeAttr('aria-hidden');
          event.preventDefault();
      }

      window.sleepless.accessibility.tabme();
      $(window.elBeforeModal).focus();
  });

  $('.closeCompare img').click(function(){
      $('.compareModal').fadeOut();
      $( '.main-content' ).attr( 'aria-hidden', 'false' );
      $('.compareModalOverlay').fadeOut();
      $('#shopify-section-compareModal').siblings().removeAttr('aria-hidden');
  });

  $('.closeCompare img').on('keypress',function(e) {
      if(e.which == 13) {
          $('.compareModal').fadeOut();
          $('.compareModalOverlay').fadeOut();
          $('#shopify-section-compareModal').siblings().removeAttr('aria-hidden');
      }
  });

  $('.compareModalOverlay').click(function(){
      $('.compareModal').fadeOut();
      $( '.main-content' ).attr( 'aria-hidden', 'false' );
      $('.compareModalOverlay').fadeOut();
  });

  $('.compareModalOverlay').on('keypress',function(e) {
      if(e.which == 13) {
          $('.compareModal').fadeOut();
          $( '.main-content' ).attr( 'aria-hidden', 'false' );
          $('.compareModalOverlay').fadeOut();
      }
  });

  $('.comparePopButton').click(function(){
      $('.compareModal').fadeIn();
      $( '.main-content' ).attr( 'aria-hidden', 'true' );
      $('.compareModalOverlay').fadeIn();

      $('#shopify-section-compareModal').siblings().attr('aria-hidden', 'true');
      sleepless.accessibility.update_keep_focused();
  });

  $('.comparePopButton').on('keypress',function(e) {
      if(e.which == 13) {
          $('.compareModal').fadeIn();
          $('.compareModalOverlay').fadeIn();
          $('#shopify-section-compareModal').siblings().attr('aria-hidden', 'true');
          sleepless.accessibility.update_keep_focused();
      }
  });

  $('.threeBlock').click(function(){
      window.location = $(this).attr('data-href');
  });

  $('.threeBlock').on('keypress',function(e) {
      if(e.which == 13) {
          window.location = $(this).attr('data-href');
      }
  });

  $('.twoBlock').click(function(){
      window.location = $(this).attr('data-href');
  });

  $('.twoBlock').on('keypress',function(e) {
      if(e.which == 13) {
          window.location = $(this).attr('data-href');
      }
  });

  $('.primeBlock').click(function(){
      window.location = $(this).attr('data-href');
  });

  $('.primeBlock').on('keypress',function(e) {
      if(e.which == 13) {
          window.location = $(this).attr('data-href');
      }
  });

  $('.videoBlock').mouseenter(function(){
      $(this).find('img').attr('src', $(this).attr('data-gif'));
  });
  $('.videoBlock').mouseleave(function(){
      $(this).find('img').attr('src', $(this).attr('data-img'));
  });
  $('.videoBlock').each(function(){
      var stringNum = $(this).attr("data-count");
      var intNum = Number(stringNum);
      if (intNum > 2){
          $(this).hide();
      }
  });
  $('.videoPage').find('.showMore').click(function(){
      $(this).parent().find('.flex').find('.videoBlock').fadeIn();
      $(this).hide();
  });

  $('.videoPage').find('.showMore').on('keypress',function(e) {
      if(e.which == 13) {
          $(this).parent().find('.flex').find('.videoBlock').fadeIn();
          $(this).hide();
      }
  });

  $('.videoPage').find('.showMore').each(function(){
      var allBlocks = $(this).parent().find('.flex').find('.videoBlock');
      var howManyBlocks = allBlocks.length;
      if ( howManyBlocks <= 3){
          $(this).hide();
      }
  });

  function preloadImage(url){
      var img=new Image();
      img.src=url;
  }
  
  $('.howApp .list .row').each(function(){
      var url = $(this).attr('data-src');
      preloadImage(url);
  });

  $('.howApp .list .row').click(function(event){
      var newSrc = $(this).attr('data-src');
      var newAlt = $(this).attr('data-alt');
      $('.howApp .container img').attr('src', newSrc);
      $('.howApp .container img').attr('alt', newAlt);
      $(event.target).parent().siblings().find('a').attr('aria-selected', 'false');
      $(event.target).attr('aria-selected', 'true');
  });

  $('.howApp .list .row').on('keypress',function(e) {
      if(e.which == 13) {
          var newSrc = $(this).attr('data-src');
          $('.howApp .container img').attr('src', newSrc);
      }
  });

  $('.fillGrid').html($('.usaGrid').html());
  $('.USA').click(function(){
      $('.fillGrid').html($('.usaGrid').html());
      $('.Canada').removeClass('active');
      $('.USA').addClass('active');
  });

  $('.USA').on('keypress',function(e) {
      if(e.which == 13) {
          $('.fillGrid').html($('.usaGrid').html());
          $('.Canada').removeClass('active');
          $('.USA').addClass('active');
      }
  });

  $('.Canada').click(function(){
      $('.fillGrid').html($('.canadaGrid').html());
      $('.USA').removeClass('active');
      $('.Canada').addClass('active');
  });

  $('.Canada').on('keypress',function(e) {
      if(e.which == 13) {
          $('.fillGrid').html($('.canadaGrid').html());
          $('.USA').removeClass('active');
          $('.Canada').addClass('active');
      }
  });

  $('.accessoriesSection').find('.imgGallery').find('.flex').find('img').click(function(){
      var buffer = $(this).attr('src');
      $(this).attr('src', $(this).parent().parent().find('.big').find('img').attr('src'));
      $(this).parent().parent().find('.big').find('img').attr('src', buffer);
  });

  $('.accessoriesSection').find('.imgGallery').find('.flex').find('img').on('keypress',function(e) {
      if(e.which == 13) {
          var buffer = $(this).attr('src');
          $(this).attr('src', $(this).parent().parent().find('.big').find('img').attr('src'));
          $(this).parent().parent().find('.big').find('img').attr('src', buffer);
      }
  });

  $('.howApp .list .row').click(function(){
      $('.howApp .list .row').removeClass('activeRow');
      $(this).addClass('activeRow');
  });

  $('.howApp .list .row').on('keypress',function(e) {
      if(e.which == 13) {
          $('.howApp .list .row').removeClass('activeRow');
          $(this).addClass('activeRow');
      }
  });

  $(':not(.keep-aria)[aria-hidden]').removeAttr('aria-hidden');

//   ExtendOffer.init()

  
  function openCart(e){
    $('[cartflow="'+e+'"]').show();
    $('.newCart').fadeIn();
    $('.newCart__overlay').fadeIn(400, function(){
      populateExtend();
    });
 	$( '.newCart__close' ).focus();
    $( '.shopify-section:not(#shopify-section-newHeader)' ).attr( 'aria-hidden', 'true' );
  }
  
  function closeCart(){
    $('[cartflow]').fadeOut();
    $('.newCart').fadeOut();
    $('.newCart__overlay').fadeOut();
	$( '.shopify-section:not(#shopify-section-newHeader)' ).attr( 'aria-hidden', 'false' );
  }
  
  function updateBubble(){
    var itemsInCart = CartJS.cart.item_count;
    $('#deskCartBuble').text(itemsInCart);
    $('#mobileCartBuble').text(itemsInCart);
    if (CartJS.cart.item_count === 0){
      $('#deskCartBuble').hide();
      $('#mobileCartBuble').hide();
  	}
    else{
      $('#deskCartBuble').show();
      $('#mobileCartBuble').show();
    }
  }
  
  function findProd(handle){
    var result = prodLibrary.find(obj => {
      return obj.handle === handle
    })
    return result;
  }
  
  function findBundle(handle, trigger){
    if (trigger != ''){
      var result = bundleLibrary.find(obj => {
        return obj.trigger === trigger
      })
      return result;
    }
    else{
      for (i=0;i<bundleLibrary.length;i++){
        if (bundleLibrary[i].trigger == ''){
          if (bundleLibrary[i].product1 == handle || bundleLibrary[i].product2 == handle || bundleLibrary[i].product3 == handle){
            return bundleLibrary[i];
          }
        }
      }
    }
  }
  
  function findText(handle){
    var result = textLibrary.find(obj => {
      return obj.handle === handle
    })
    return result;
  }
  
  function preloadImage(url)
  {
    var img=new Image();
    img.src=url;
  }
  
  function fillOption(object, index, variant){
    var target = $('[newoption="'+index+'"]');
    
    var extraText = '';
    if (findText(object.handle) != undefined){
    extraText = findText(object.handle);
    }
    
    for (i=0;i<object.variants.length;i++){
      preloadImage(object.variants[i].image);
    }
    
    target.find('.optionCard__text').text('');
    
    target.find('.optionCard__image').attr('src', object.variants[variant].image);
    // target.find('.optionCard__image').attr('alt', object.title);
    
    target.find('.optionCard__title').text(object.title);
    if (object){
      var discounted = false;
      for (i=0;i<discountProds.length;i++){
        if (discountProds[i].handle == object.handle){
          discounted = discountProds[i]["discount_price"];
        }
      }
      if (discounted == false){
        target.find('.optionCard__price').text('$'+object.price);
      }
      else{
        target.find('.optionCard__price').html(discounted + ' <s>$'+object.price+'</s>');
      }
    }
    
    
    target.find('.optionCard__text').text(extraText.text);
    
    target.find('.optionCard__inner').attr('data-code', object.variants[variant].id);
    target.find('.optionCard__inner').attr('data-available', object.variants[variant].available);
    target.find('.optionCard__inner').attr('data-handle', object.handle);
    
    if (object.variants[variant].available == "false"){
      target.find('.optionCard__price').addClass('optionCard__price--soldOut').text('SOLD OUT');
    }
    else{
      target.find('.optionCard__price').removeClass('optionCard__price--soldOut')
    }

    
    
    if (object.handle == 'august-smart-lock-pro' || object.handle == 'august-smart-lock-3rd-generation'){
      target.find('.optionCard__under').addClass('optionCard__underArmed');
      target.find('.optionCard__underLink').attr('href', '/products/'+object.handle);
    }
    else{
      target.find('.optionCard__under').removeClass('optionCard__underArmed');
    }
    
    //if (object.variants[variant].available == 'true'){
    target.show();
    //}else{
      //target.hide();
    //}
  }
  
  function clearOption(index){
    var target = $('[newoption="'+index+'"]');
    
    target.find('.optionCard__image').attr('src', '');
    target.find('.optionCard__image').attr('alt', '');
    
    target.find('.optionCard__title').text('');
    target.find('.optionCard__price').text('');
    target.find('.optionCard__text').text('');
    
    target.find('.optionCard__inner').attr('data-code', '');
    target.find('.optionCard__inner').attr('data-available', '');
    target.find('.optionCard__inner').attr('data-handle', '');
    
    target.find('.optionCard__under').removeClass('optionCard__underArmed');
    target.find('.optionCard__underLink').attr('href', '');
    
    target.hide();
  }
  
  
  window.Extend.config({ storeId: '2798ad2f-a9cb-4ed0-b787-30ea6b2dfc2b' });
  

  Extend.buttons.render('#newCart__extend', {
    referenceID: '31623807107146',
  });
 
  
  
  function populateExtend(){
    if ($('#newCart__extend').find('.extend-product-offer').length){
      var code = $('.optionCard--active').find('.optionCard__inner').attr('data-code');
      

      var component = Extend.buttons.instance('#newCart__extend');
      
      component.setActiveProduct(code);

      window.dispatchEvent(new Event('resize'));
    }
  }
  
  function populateShopping(e){
    var special = '';
    if (e.attr('special')){
    	special = e.attr('special');
    }
    var variant = 0;
    if (e.attr('data-variant-index')){
      variant = e.attr('data-variant-index') - 1;
    }
    
    var handle = e.attr('data-product');
    
    var bundle = findBundle(handle, special);
    console.log(bundle);
    
    var originalProd = findProd(handle);
    console.log(originalProd);
    
    var prod1;
    var prod2;
    var prod3;
    
    clearOption(2);
    clearOption(3);
    
    console.log(originalProd.handle);
    
    if (bundle != undefined){
      prod1 = findProd(bundle.product1);
      console.log(prod1);
      
      $('.optionCard').removeClass('optionCard--active');
      $('[newoption="1"]').addClass('optionCard--active');
      console.log(prod1.handle);
      
      fillOption(prod1, 1, variant);
      if (bundle.product2 != ''){
        prod2 = findProd(bundle.product2);
        fillOption(prod2, 2, variant);
        
        console.log(prod2.handle);
        
        if (prod2.handle == originalProd.handle){
          $('.optionCard').removeClass('optionCard--active');
          $('[newoption="2"]').addClass('optionCard--active');
        }
      }
      if (bundle.product3 != ''){
        prod3 = findProd(bundle.product3);
        fillOption(prod3, 3, variant);
        
        console.log(prod3.handle);
        
        if (prod3.handle == originalProd.handle){
          $('.optionCard').removeClass('optionCard--active');
          $('[newoption="3"]').addClass('optionCard--active');
        }
      }
    }
    else{
      $('.optionCard').removeClass('optionCard--active');
      $('[newoption="1"]').addClass('optionCard--active');
      console.log(originalProd);
      prod1 = originalProd;
      fillOption(prod1, 1, variant);
    }
    
    $('.optionCard__inner').first().click();
    
    console.log(originalProd.title);
    if (originalProd.title.indexOf("August Wi-Fi Smart Lock + Deadbolt") >= 0){
      $('.newCart__title').text('August Wi-Fi Smart Lock + Deadbolt');
    }
    else{
      $('.newCart__title').text(originalProd.title);
    }
    
    $('[newcolor]').hide();
    /*
    if (bundle != undefined){
      for (i=0;i<prod1.variants.length;i++){
        var adjusted = i+1;
        var target = $('[newcolor="'+adjusted+'"]');
        target.find('.newCart__colorCircle').attr('style', 'background-color:'+prod1.variants[i].hex+';');
        target.find('.newCart__colorName').text(prod1.variants[i].name);
        target.show();
      }
      if (bundle.product2 != ''){
        for (i=0;i<prod2.variants.length;i++){
          var adjusted = i+1;
          var target = $('[newcolor="'+adjusted+'"]');
          if (target.is(':visible')){}else{
            target.find('.newCart__colorCircle').attr('style', 'background-color:'+prod2.variants[i].hex+';');
            target.find('.newCart__colorName').text(prod2.variants[i].name);
            target.show();
          }
        }
      }
      if (bundle.product3 != ''){
        for (i=0;i<prod3.variants.length;i++){
          var adjusted = i+1;
          var target = $('[newcolor="'+adjusted+'"]');
          if (target.is(':visible')){}else{
            target.find('.newCart__colorCircle').attr('style', 'background-color:'+prod3.variants[i].hex+';');
            target.find('.newCart__colorName').text(prod3.variants[i].name);
            target.show();
          }
        }
      }
    }
    else{
      for (i=0;i<prod1.variants.length;i++){
        var adjusted = i+1;
        var target = $('[newcolor="'+adjusted+'"]');
        target.find('.newCart__colorCircle').attr('style', 'background-color:'+prod1.variants[i].hex+';');
        target.find('.newCart__colorName').text(prod1.variants[i].name);
        target.show();
      }
    }*/
    
    for (i=0;i<originalProd.variants.length;i++){
        var adjusted = i+1;
        var target = $('[newcolor="'+adjusted+'"]');
      
      	var result = colorLibrary.find( ({ name }) => name === originalProd.variants[i].name );
      	
      if (typeof result !== "undefined"){
        target.find('.newCart__colorCircle').attr('style', 'background:'+result.background+';background-size:cover;');
      }
      else{
        target.find('.newCart__colorCircle').attr('style', 'background:'+originalProd.variants[i].hex+';background-size:cover;');
      }
        target.find('.newCart__colorName').text(originalProd.variants[i].name);
        target.attr('aria-label', "select "+originalProd.variants[i].name+" color")
        target.show();
      }
    
    $('.newCart__colors').show();
    if ($('[newcolor="2"]').find('.newCart__colorName').text().trim() == '' ){
      $('.newCart__colors').hide();
    }
    // remove this if the color ever comes back in
    if ($('.newCart__title').text().includes('August Smart Lock Pro')){
      $('.newCart__colors').hide();
    }
    
    if (prod1){
      var subtotal_discounted = false;
      for (i=0;i<discountProds.length;i++){
        if (discountProds[i].handle == prod1.handle){
          subtotal_discounted = discountProds[i]["discount_price"];
        }
      }
      if (subtotal_discounted == false){
        $('.newCart__shopSubPrice').text('$'+prod1.price);
      }
      else{
        $('.newCart__shopSubPrice').html(subtotal_discounted + ' <s>$'+prod1.price+'</s>');
      }
    }
    else{
      var subtotal_discounted = false;
      for (i=0;i<discountProds.length;i++){
        if (discountProds[i].handle == originalProd.handle){
          subtotal_discounted = discountProds[i]["discount_price"];
        }
      }
      if (subtotal_discounted == false){
        $('.newCart__shopSubPrice').text('$'+originalProd.price);
      }
      else{
        $('.newCart__shopSubPrice').html(subtotal_discounted + ' <s>$'+originalProd.price+'</s>');
      }
    }
    
    $('.newCart__colorButton').removeClass('newCart__colorButton--active');
    $('.newCart__colorButton[newcolor="'+(variant + 1)+'"]').addClass('newCart__colorButton--active');

if (originalProd.variants[0].available == "false"){
      $('.newCart__addCartWrapper').hide();
      $('.notifyMe notifyMe--miniCart').show();
    }
    else{
      $('.newCart__addCartWrapper').show();
      $('.notifyMe notifyMe--miniCart').hide();
    }
    
  }
  
  $('#shopify-section-smart-lock-pro-v10').find('.specs').find('.slick-dots').hide();
  
  $('.featuredDCard__colorButton').each(function(){
    var colorName = $(this).attr('name');
    var result = colorLibrary.find( ({ name }) => name === colorName );
    if (typeof result !== "undefined"){
    $(this).attr('style', 'background:'+result.background+';background-size:cover;');
    }
  });
  
  $('.EGCMainBlade__colorButton').each(function(){
    var colorName = $(this).attr('color-code');
    var result = colorLibrary.find( ({ name }) => name === colorName );
    if (typeof result !== "undefined"){
    $(this).find('.EGCMainBlade__colorButtonInner').attr('style', 'background:'+result.background+';background-size:cover;');
    }
  });
  
  var initialBubbleSet = setInterval(function(){
    if (CartJS.cart.item_count != undefined){
    updateBubble();
      clearInterval(initialBubbleSet);
    }
  }, 500);

  $('.cart-link').on('click', function(){
    var itemsInCart = CartJS.cart.item_count;
    if (itemsInCart == 0){
      $('.newCart__title').text('Your Cart');
      openCart('empty');
      $('.newCart__back').hide();
    }
    else{
      renderFullCart();
      $('.newCart__title').text('Your Cart');
      openCart('cart');
      $('.newCart__back').hide();
    }
  });
  
  $('[newcartclose]').on('click', closeCart);
  
  $('[data-product]').on('click', function(){
    if (!$(this).hasClass('notifyMe__submit')){
      populateShopping($(this));
      openCart('shopping');
      $('.newCart__back').hide();
    }
  });
  
  $('.colBlade__slider').on('init', function(event, slick){
    $('[data-product]').on('click', function(){
      if (!$(this).hasClass('notifyMe__submit')){
        populateShopping($(this));
        openCart('shopping');
        $('.newCart__back').hide();
      }
    });
  });
  
  $('[newcolor]').on('click', function(){
    
    $('.newCart__colorButton').removeClass('newCart__colorButton--active');
    $(this).addClass('newCart__colorButton--active');
    
    var index = $(this).attr('newcolor');
    index--;
    
    var obj1;
    var obj2;
    var obj3;
    
    var handle1 = $('[newoption="1"]').find('.optionCard__inner').attr('data-handle');
    var handle2 = $('[newoption="2"]').find('.optionCard__inner').attr('data-handle');
    var handle3 = $('[newoption="3"]').find('.optionCard__inner').attr('data-handle');
    
    if (handle1){
      obj1 = findProd(handle1);
      if (obj1.variants.length >= (index + 1)){
        fillOption(obj1, 1, index);
      }
      else{
        $('[newoption="1"]').hide();
      }
    }
    if (handle2){
      obj2 = findProd(handle2);
      if (obj2.variants.length >= (index + 1)){
        fillOption(obj2, 2, index);
      }
      else{
        $('[newoption="2"]').hide();
      }
    }
    if (handle3){
      obj3 = findProd(handle3);
      if (obj3.variants.length >= (index + 1)){
        fillOption(obj3, 3, index);
      }
      else{
        $('[newoption="3"]').hide();
      }
    }
    if ($('.optionCard--active').is(':visible')){}else{
      var stop = 0;
      $('.optionCard').each(function(){
        if (stop == 0){
          if ($(this).is(':visible')){
			$('.optionCard').removeClass('optionCard--active');
            $(this).addClass('optionCard--active');
            stop = 1;
          }
        }
      });
    }
    populateExtend();
    
    $('.optionCard--active .optionCard__inner').click();

    if($('.optionCard--active .optionCard__inner').attr('data-available') == "false"){
      $('.newCart__addCartWrapper').hide();
      $('.payment-options').hide();
      $('.notifyMe--miniCart').show();
    }
    else{
      $('.newCart__addCartWrapper').show();
      $('.payment-options').show();
      $('.notifyMe--miniCart').hide();
    }
  });
  
  function renderCartItem(index, image, title, color, price, quantity){
    var trashImg = "https://cdn.shopify.com/s/files/1/1354/7835/files/trash.png?15879332028067968505"
    var bigText = '<div class="newLineItem" data-index="'+index+'"><div class="newLineItem__inner"><div class="newLineItem__left"><img class="newLineItem__img" src="'+image+'" alt="'+title+'"></div><div class="newLineItem__right"><div class="newLineItem__title">'+title+'</div><div class="newLineItem__color">'+color+'</div><div class="newLineItem__price">$'+price+'</div><input type="number" min="1" value="'+quantity+'"><span class="newLineItem__qty">Qty</span><button class="newLineItem__remove"><img class="newLineItem__removeIcon" src="'+trashImg+'" alt="remove item from cart"></button></div></div></div>';
    var currentString = $('.newCart__cartFlex').html();
    $('.newCart__cartFlex').html(currentString + bigText);
    
    $('.newLineItem').find('input').on('change', function(){
      
      var index = $(this).parent().parent().parent().attr('data-index');
      var newValue = $(this).val();
      CartJS.updateItem(index, newValue);
      
      var initialCount = CartJS.cart.item_count;
      
      var changeWatch = setInterval(function(){
        var newCount = CartJS.cart.item_count;
        if (initialCount != newCount){
          updateBubble();
          renderFullCart();
          
          clearInterval(changeWatch);
        }
      }, 100);
      
    });
    
    var ready = true;
    
    $('.newLineItem__remove').on('click', function(){
      if (ready == true){
        
      ready = false;
        
      var index = $(this).parent().parent().parent().attr('data-index');
      CartJS.removeItem(index);
      
        $(this).parent().parent().parent().slideUp(400, function(){
          renderFullCart();
        });
      
      var initialCount = CartJS.cart.item_count;
      
      var changeWatch = setInterval(function(){
        var newCount = CartJS.cart.item_count;
        if (initialCount != newCount){
          updateBubble();
          
          ready = true;
          
          if (newCount == 0){
            $('.newCart__inner--cart').fadeOut(400, function(){
              $('.newCart__inner--empty').fadeIn();
            });
          }
          
          clearInterval(changeWatch);
        }
      }, 100);
        
      }
    });
  }
  
  function renderFullCart(){
    $('.newCart__cartFlex').html('');
    
    var cartArray = CartJS.cart.items;
    $('[testtitle]').show();
    for (i=0;i<cartArray.length;i++){
      var index = i+1;
      var image = cartArray[i].featured_image.url;
      var title = cartArray[i].product_title;
      var color = "";
      for (var j = 0;j<cartArray[i].options_with_values.length;j++){
        if (cartArray[i].options_with_values[j].name == "Color" || cartArray[i].options_with_values[j].name == "Finish"){
          color = cartArray[i].options_with_values[j].value;
        }
      }
      var price = cartArray[i].final_line_price;
      price = (price / 100).toFixed(2);
      var quantity = cartArray[i].quantity;
      renderCartItem(index, image, title, color, price, quantity);
      
      
      
      if($('[testtitle="'+title+'"]').length){
        $('[testtitle="'+title+'"]').hide();
      }
      
      if (title.indexOf("Keypad") >= 0){
        if ($('[testtitle="Smart Keypad"]').length){
        	$('[testtitle="Smart Keypad"]').hide();
        }
      }
      
      if (title.indexOf("Connect") >= 0){
        if ($('[testtitle="Connect Wi-Fi Bridge"]').length){
        	$('[testtitle="Connect Wi-Fi Bridge"]').hide();
        }
      }
      
      if (title.indexOf("Wi-Fi") >= 0){
        if ($('[testtitle="Connect Wi-Fi Bridge"]').length){
        	$('[testtitle="Connect Wi-Fi Bridge"]').hide();
        }
      }

    }
    var subTotal = CartJS.cart.items_subtotal_price;
    subTotal = (subTotal / 100).toFixed(2);
    
    $('.newCart__cartSubPrice').text('$'+subTotal);
    $('.bm-total-price').text('$'+subTotal);
    
  };
  
  $('.newUpCard__add').on('click', function(){
    var variant = $(this).attr('prodid');
    var initialCount = CartJS.cart.item_count;
    CartJS.addItem(variant, 1, {}, {
          
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        
        var changeWatch = setInterval(function(){
          var newCount = CartJS.cart.item_count;
          if (initialCount != newCount){
            updateBubble();
            renderFullCart();
            clearInterval(changeWatch);
          }
        }, 100);
      },

      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('error');
      }

    });
    
  });
  
  function shoppingToCart(initialCount){
    var changeWatch = setInterval(function(){
      var newCount = CartJS.cart.item_count;
      if (initialCount != newCount){
        updateBubble()
        $('.newCart__inner--shopping').fadeOut(400, function(){
          $('.newCart__inner--cart').fadeIn();
          $('.newCart__back').fadeIn();
          $('.newCart__title').text('Your Cart');
          renderFullCart();
        });
        clearInterval(changeWatch);
      }
    }, 100);
  }
  
  $('.newCart__back').on('click', function(){
    $('.newCart__inner--cart').fadeOut(400, function(){
      $('.newCart__inner--shopping').fadeIn();
      $('.newCart__back').fadeOut();
      var title = $('.optionCard--active').find('.optionCard__title').text();
      if (title.indexOf("August Wi-Fi Smart Lock + Deadbolt") >= 0){
        $('.newCart__title').text('August Wi-Fi Smart Lock + Deadbolt');
      }
      else{
        $('.newCart__title').text(title);
      }
      
      window.dispatchEvent(new Event('resize'));
    });
  });
  
  function trackAddedToCart(){
    var itemNames = [];
    for (i=0;i<CartJS.cart.items.length;i++){
      itemNames.push(CartJS.cart.items[i].title);
    }
    var items = [];
    for (i=0;i<CartJS.cart.items.length;i++){
      var item = {
        "ProductID": CartJS.cart.items[i].id,
        "SKU": CartJS.cart.items[i].sku,
        "ProductName": CartJS.cart.items[i].title,
        "Quantity": CartJS.cart.items[i].quantity,
        "ItemPrice": CartJS.cart.items[i].price / 100,
        "RowTotal": CartJS.cart.items[i].line_price / 100,
        "ProductURL": "http://www.example.com"+CartJS.cart.items[i].url,
        "ImageURL": CartJS.cart.items[i].image,
        "ProductCategories": [CartJS.cart.items[i].product_type]
      }
      items.push(item);
    }
    
    _learnq.push(["track", "Added to Cart", {
     "$value": (CartJS.cart.total_price / 100),
     "AddedItemProductName": CartJS.cart.items[0].title,
     "AddedItemProductID": CartJS.cart.items[0].id,
     "AddedItemSKU": CartJS.cart.items[0].sku,
     "AddedItemCategories": [CartJS.cart.items[0].product_type],
     "AddedItemImageURL": CartJS.cart.items[0].image,
     "AddedItemURL": "http://www.august.com"+CartJS.cart.items[0].url,
     "AddedItemPrice": (CartJS.cart.items[0].line_price / 100),
     "AddedItemQuantity": 1,
     "ItemNames": itemNames,
     "CheckoutURL": "http://www.august.com/checkout",
     "Items": items
   }]);
  }
  
  function addSelectedItem(variant, quantity){
    CartJS.addItem(variant, quantity, {}, {
          
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        var initialCount = CartJS.cart.item_count;
        shoppingToCart(initialCount);
        
        var element = CartJS.cart.item_count;
        var intervalID = setInterval(function(){
          if (element === CartJS.cart.item_count){
          }
          else{
            //when the serverside count increases continue with buy flow
            trackAddedToCart();
          }
        },100);
        
      },

      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log('error');
      }

    });
  }
  
  $('[href="/checkout"]').on('click', function(e){
    e.preventDefault();
    
    var itemNames = [];
    for (i=0;i<CartJS.cart.items.length;i++){
      itemNames.push(CartJS.cart.items[i].title);
    }
    
    var items = [];
    for (i=0;i<CartJS.cart.items.length;i++){
      var item = {
        "ProductID": CartJS.cart.items[i].id,
        "SKU": CartJS.cart.items[i].sku,
        "ProductName": CartJS.cart.items[i].title,
        "Quantity": CartJS.cart.items[i].quantity,
        "ItemPrice": CartJS.cart.items[i].price / 100,
        "RowTotal": CartJS.cart.items[i].line_price / 100,
        "ProductURL": "http://www.example.com"+CartJS.cart.items[i].url,
        "ImageURL": CartJS.cart.items[i].image,
        "ProductCategories": [CartJS.cart.items[i].product_type]
      }
      items.push(item);
    }
    
    _learnq.push(["track", "Started Checkout", {
     "$event_id": (Math.random() * (9999999 - 1000000) + 1000000)+"_"+Date.now(),
     "$value": (CartJS.cart.total_price / 100),
     "ItemNames": itemNames,
     "CheckoutURL": "http://www.august.com/checkout",
     "Categories": ["Unable to track"],
     "Items": items
   }]);
    
    window.location.href = "/checkout";
  });
  
  function newAddCart(){
    const quantity = $('.newCart__shopQuantSelect').val();
    const variant = $('.optionCard--active').find('.optionCard__inner').attr('data-code');
    if ($('#newCart__extend').find('.extend-product-offer').length){
      const component = Extend.buttons.instance('#newCart__extend');
      const plan = component.getPlanSelection();
      const product = component.getActiveProduct();
      

      if (plan){
        ExtendShopify.addPlanToCart({ plan, product, quantity }, function(){
          console.log('plan added');
          addSelectedItem(variant, quantity);
        });
      }
      else{
        Extend.modal.open({
          referenceId: variant,
          onClose: function(plan, product) {
            if (plan && product) {
              ExtendShopify.addPlanToCart({ plan, product, quantity }, function(){
                console.log('plan added');
                addSelectedItem(variant, quantity);
              });
            } else {
              console.log('plan not added');
              addSelectedItem(variant, quantity);
            }
          },
        })
      }
    }
    else{
      addSelectedItem(variant, quantity);
    }
  }
  
  
  
  function standardAddCart(){
    const quantity = $('.newPDPMain__qty').val();
    const variant = $('.newPDPMain__colorButton--active').attr('variant-id');
    if ($('#newPDPMain__affirmRow').find('.extend-product-offer').length){
      const component = Extend.buttons.instance('#newPDPMain__affirmRow');
      const plan = component.getPlanSelection();
      const product = component.getActiveProduct();
      
      if (plan){
        ExtendShopify.addPlanToCart({ plan, product, quantity }, function(){
          addSelectedItem(variant, quantity);
          openCart('cart');
        });
      }
      else{
        addSelectedItem(variant, quantity);
        openCart('cart');
      }
    }
    else{
      addSelectedItem(variant, quantity);
      openCart('cart');
    }
  }
  
  $('.newPDPMain__buyButton').on('click', function(){
    standardAddCart();
  });
  
  function populateNewExtend(){
    if ($('#newPDPMain__affirmRow').find('.extend-product-offer').length){
      var code = $('.newPDPMain__productButton--active').attr('prod-id');

      var component = Extend.buttons.instance('#newPDPMain__affirmRow');
      
      component.setActiveProduct(code);

      //window.dispatchEvent(new Event('resize'));
    }
  }
  
  if ($('#newPDPMain__affirmRow').length){
    Extend.buttons.render('#newPDPMain__affirmRow', {
      referenceID: '31623807107146',
    });
  }
  
  setInterval(function(){
    
    if ($('#newPDPMain__affirmRow .extend-product-offer iframe').length == 0){
      populateNewExtend();
    }
  }, 500);
  
  function addCartNoPopup(){
    const quantity = $('.newCart__shopQuantSelect').val();
    const variant = $('.optionCard--active').find('.optionCard__inner').attr('data-code');
    if ($('#newCart__extend').find('.extend-product-offer').length){
      const component = Extend.buttons.instance('#newCart__extend');
      const plan = component.getPlanSelection();
      const product = component.getActiveProduct();

      if (plan){
        ExtendShopify.addPlanToCart({ plan, product, quantity }, function(){
          console.log('plan added');
          addSelectedItem(variant, quantity);
        });
      }
      else{
        addSelectedItem(variant, quantity);
      }
    }
    else{
      addSelectedItem(variant, quantity);
    }
  }
  
  $('.newCart__addCart').on('click', newAddCart);
  $('.newCart__addCart--noPopup').on('click', addCartNoPopup);
  
  $('.optionCard__inner').on('click', function(){
    $('.optionCard').removeClass('optionCard--active');
    $(this).parent().addClass('optionCard--active');
    
    if ($(this).attr('data-available') === 'true'){
      $('.newCart__addCartWrapper').find('button').prop('disabled', false);
      $('.newCart__addCartWrapper').find('button').text('Add to cart');
      console.log('in stock');
    }
    else{
      $('.newCart__addCartWrapper').find('button').prop('disabled', true);
      $('.newCart__addCartWrapper').find('button').text('Out of Stock');
      console.log('out of stock');
    }
    
    populateExtend();
    $('.newCart__shopSubPrice').html($(this).find('.optionCard__price').html());
    
    var handle = $(this).attr('data-handle');
    
    var originalProd = findProd(handle);
    
    $('[newcolor]').hide();
    
    for (i=0;i<originalProd.variants.length;i++){
        var adjusted = i+1;
        var target = $('[newcolor="'+adjusted+'"]');
      
      	var result = colorLibrary.find( ({ name }) => name === originalProd.variants[i].name );
      	
      if (typeof result !== "undefined"){
        target.find('.newCart__colorCircle').attr('style', 'background:'+result.background+';background-size:cover;');
      }
      else{
        target.find('.newCart__colorCircle').attr('style', 'background:'+originalProd.variants[i].hex+';background-size:cover;');
      }
        target.find('.newCart__colorName').text(originalProd.variants[i].name);
        target.show();
      
      if (originalProd.variants[i].available == "true"){
        target.find('.newCart__colorCircle').removeClass('newCart__colorCircle--unavailable');
      }
      else{
        target.find('.newCart__colorCircle').addClass('newCart__colorCircle--unavailable');
      }
    }
    
    if($('.optionCard--active .optionCard__inner').attr('data-available') == "false"){
      $('.newCart__addCartWrapper').hide();
      $('.payment-options').hide();
      $('.newCart__shopQuant').hide();
      $('.newCart__shopQuant').hide();
      $('.notifyMe--miniCart').show();
    }
    else{
      $('.newCart__addCartWrapper').show();
      $('.payment-options').show();
      $('.newCart__shopQuant').show();
      $('.newCart__shopQuant').show();
      $('.notifyMe--miniCart').hide();
    }

    
  });
  
  
  $('.featuredDCard__colorButton').each(function(){
      var url = $(this).attr('image');
      preloadImage(url);
  });
  
  $('.featuredDCard__colorButton').on('click', function(){
    var image = $(this).attr('image');
    var name = $(this).attr('name');
    
    $
    $(this).parent().parent().find('.featuredDCard__colorTitle').text(name);
    $(this).parent().parent().parent().find('.featuredDCard__img').attr('src', image);
    $(this).parent().find('.featuredDCard__colorButton').removeClass('featuredDCard__colorButton--active');
    $(this).addClass('featuredDCard__colorButton--active');
    $(this).parent().find('.featuredDCard__colorButton').attr('aria-current', 'false');
    $(this).attr('aria-current', 'true');
  });
  
  $('[alt="August Wi-Fi Smart Lock in matte black finish"]').parent().parent().find('.featuredDCard__colorButton').removeClass('featuredDCard__colorButton--active');
  $('[alt="August Wi-Fi Smart Lock in matte black finish"]').parent().parent().find('.featuredDCard__colorRow').find('[name="Matte Black"]').addClass('featuredDCard__colorButton--active');
  $('[alt="August Wi-Fi Smart Lock in matte black finish"]').parent().parent().find('.featuredDCard__colorTitle').text('Matte Black');
  /*
  $('[alt="August Smart Lock Smart Hosting Bundle Silver"]').parent().parent().find('.featuredDCard__colorButton').removeClass('featuredDCard__colorButton--active');
  $('[alt="August Smart Lock Smart Hosting Bundle Silver"]').parent().parent().find('.featuredDCard__colorRow').find('[name="Satin Nickel"]').addClass('featuredDCard__colorButton--active');
  $('[alt="August Smart Lock Smart Hosting Bundle Silver"]').parent().parent().find('.featuredDCard__colorTitle').text('Satin Nickel');

  $('[alt="August Wi-Fi Smart Lock + Pad Lock"]').parent().parent().find('.featuredDCard__colorButton').removeClass('featuredDCard__colorButton--active');
  $('[alt="August Wi-Fi Smart Lock + Pad Lock"]').parent().parent().find('.featuredDCard__colorRow').find('[name="Black with Satin Nickel"]').addClass('featuredDCard__colorButton--active');
  $('[alt="August Wi-Fi Smart Lock + Pad Lock"]').parent().parent().find('.featuredDCard__colorTitle').text('Black with Satin Nickel');
  
  $('[alt="August Smart Lock Pro + Keypad"]').parent().parent().find('.featuredDCard__colorButton').removeClass('featuredDCard__colorButton--active');
  $('[alt="August Smart Lock Pro + Keypad"]').parent().parent().find('.featuredDCard__colorRow').find('[name="Matte Black"]').addClass('featuredDCard__colorButton--active');
  $('[alt="August Smart Lock Pro + Keypad"]').parent().parent().find('.featuredDCard__colorTitle').text('Matte Black');
  */
  $('.newCart__colorsLabel').text('Smart Lock Color Options');
  
  $('#shopify-section-renterSticky').addClass('primeSticky');
  $('#shopify-section-customizeSticky').addClass('primeSticky');
  
  setInterval(function(){
  var height = $('.navBar').outerHeight();
  $('#shopify-section-prodSticky, .prodSticky__wrapper').attr('style', 'top:'+height+'px;');
  }, 10);

  function prefetchImages(url) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(xhr.responseText, 'text/html');
        var images = doc.getElementsByTagName('img');
        for (var i = 0; i < images.length; i++) {
          var img = images[i];
          var src = img.getAttribute('src');
          var xhr2 = new XMLHttpRequest();
          xhr2.open('GET', src, true);
          xhr2.send();
        }
      }
    };
    xhr.send();
  }

  $('a').each(function(){
    var thisHref = $(this).attr('href');

    if (typeof thisHref !== 'undefined' && attr !== false) {
      if (thisHref.indexOf("/a/s") >= 0){
        if (thisHref.indexOf("www.") == 0 || thisHref.indexOf("august") >= 0){
          thisHref.replace("/a/s/", "/");
          $(this).attr('href', thisHref);
        }
      }
    }
  });

  

  $('.colCard22__colorButton').on('click', function(){
    var target = $(this).closest('.colCard22');
    target.find('.colCard22____buy').attr('data-variant-index', $(this).attr('data-index'));
    target.find('.colCard22__colorWrapper').removeClass('colCard22__colorWrapper--active');
    $(this).parent().addClass('colCard22__colorWrapper--active');
  });

  $('.colCard22__colorRow').each(function(){
    if ($(this).find('.colCard22__colorWrapper').length < 2){
      $(this).hide();
    }
  });

  $('.colCard22__keypadButton').on('click', function(){
    var target = $(this).closest('.colCard22');
    if ($(this).hasClass('colCard22__keypadButton--active')){
      $(this).removeClass('colCard22__keypadButton--active');
      target.find('.colCard22____buy').attr('data-product', $(this).attr('data-normal-handle'));
    }
    else{
      $(this).addClass('colCard22__keypadButton--active');
      target.find('.colCard22____buy').attr('data-product', $(this).attr('data-keypad-handle'));
    }
  });

  var allColorArray = [];
  var allTypeArray = [];
  $('.colCard22').each(function(){
    var thisColors = $(this).attr('data-colors').split(',');
    var thisType = $(this).attr('data-type');

    for (i=0;i<thisColors.length;i++){
      if(jQuery.inArray(thisColors[i], allColorArray) == -1 && thisColors[i] != ''){
        allColorArray.push(thisColors[i]);
      }
    }

    if(jQuery.inArray(thisType, allTypeArray) == -1  && thisType != ''){
      allTypeArray.push(thisType);
    }
  });

  for (i=0;i<allColorArray.length;i++){
    var addedOption = $('.shopAll__filter--color').html() + '<option value="'+allColorArray[i]+'">'+allColorArray[i]+'</option>';
    $('.shopAll__filter--color').html(addedOption);
  }

  for (i=0;i<allTypeArray.length;i++){
    var addedOption = $('.shopAll__filter--type').html() + '<option value="'+allTypeArray[i]+'">'+allTypeArray[i]+'</option>';
    $('.shopAll__filter--type').html(addedOption);
  }

  $('.shopAll__filter--color, .shopAll__filter--type').on('change', function(){
    
    var sortColor = $('.shopAll__filter--color').val();
    var sortType = $('.shopAll__filter--type').val();
    $('.colCard22').each(function(){
      var match = false;
      var thisColorArray = $(this).attr('data-colors').split(',');
      var thisType = $(this).attr('data-type');
      if((jQuery.inArray(sortColor, thisColorArray) !== -1 || sortColor == 'all') && (sortType == thisType || sortType == 'all')){
        match = true;
      }
      if (match == false){
        $(this).removeClass('colCard22--shown');
      }
      else{
        $(this).addClass('colCard22--shown');
      }
    });
    $('.shopAllType').each(function(){
      if ($(this).find('.colCard22--shown').length < 1){
        $(this).hide();
      }
      else{
        $(this).show();
      }
    });
  });

  $('.shopAll__filter--sort').on('change', function(){
    var chosenValue = $(this).val();
    if (chosenValue == 'most-popular'){
      $('.colCard22').attr('style', '');
    }
    else if (chosenValue == 'a-z'){
      $('.shopAllType').each(function(){
        var titleArray = [];
        $(this).find('.colCard22').each(function(){
          titleArray.push($(this).attr('data-handle'));
        });
        titleArray.sort();
        for (i=0;i<titleArray.length;i++){
          console.log(titleArray[i]);
          $(this).find('[data-handle="'+titleArray[i]+'"]').attr('style','order:'+i+';');
        }
      });
    }
    else if (chosenValue == 'z-a'){
      $('.shopAllType').each(function(){
        var titleArray = [];
        $(this).find('.colCard22').each(function(){
          titleArray.push($(this).attr('data-handle'));
        });
        titleArray.sort();
        titleArray.reverse();
        for (i=0;i<titleArray.length;i++){
          console.log(titleArray[i]);
          $(this).find('[data-handle="'+titleArray[i]+'"]').attr('style','order:'+i+';');
        }
      });
    }
    else if (chosenValue == 'lowest-price'){
      $('.colCard22').each(function(){
        var price = $(this).attr('data-price');
        $(this).attr('style', 'order:'+price+';');
      });
    }
    else if (chosenValue == 'highest-price'){
      $('.colCard22').each(function(){
        var price = $(this).attr('data-price');
        $(this).attr('style', 'order:-'+price+';');
      });
    }
  });

  $('.shopAll__clearFilter').on('click', function(){
    $(".shopAll__filter").each(function(){
      $(this).val($(this).find("option:first").val()).change();
    });
  });

  $('.newPDPMain__colorButtonRow').each(function(){
    if ($(this).find('.newPDPMain__colorButton').length < 2){
      $(this).hide();
    }
  });

  setInterval(function(){
    $('[role="tab"]').each(function(){
      
      $(this).closest('.slick-dots').attr('role', 'tablist');
    });
    $('img').each(function(){
      if(!$(this).prop("alt")){
        $(this).attr('alt', '');
      }
    });
  }, 100);

  $('.approachSwapper__button').on('click', function(){
    var thisContainer = $(this).closest('.approachSwapper');
    var thisIndex = $(this).attr('data-index');
    thisContainer.find('.approachSwapper__button').removeClass('approachSwapper__button--active');
    thisContainer.find('.approachSwapper__image').removeClass('approachSwapper__image--active');

    thisContainer.find('.approachSwapper__button[data-index="'+thisIndex+'"]').addClass('approachSwapper__button--active');
    thisContainer.find('.approachSwapper__image[data-index="'+thisIndex+'"]').addClass('approachSwapper__image--active');
  });

  $('.approachSafety__button').on('click', function(){
    var thisContainer = $(this).closest('.approachSafety');
    var thisIndex = $(this).parent().attr('data-index');
    thisContainer.find('.approachSafety__buttonWrapper').removeClass('approachSafety__buttonWrapper--active');
    thisContainer.find('.approachSafety__lowerImage').removeClass('approachSafety__lowerImage--active');

    thisContainer.find('.approachSafety__buttonWrapper[data-index="'+thisIndex+'"]').addClass('approachSafety__buttonWrapper--active');
    thisContainer.find('.approachSafety__lowerImage[data-index="'+thisIndex+'"]').addClass('approachSafety__lowerImage--active');
  });

  const approachManageUpperSlider = new Swiper('.approachManage__mobileUpperSliderContainer', {
      pagination: {
        el: '.approachManage__dots',
      },
      navigation: {
        nextEl: '.approachManage__next',
        prevEl: '.approachManage__previous',
      }
    });

    const approachManageLowerSlider = new Swiper('.approachManage__mobileLowerSliderContainer', {
      pagination: {
        el: '.approachManage__dots',
      },
      navigation: {
        nextEl: '.approachManage__next',
        prevEl: '.approachManage__previous',
      }
    });

  const approachAppSlider = new Swiper('.approachApp__mobileSliderContainer', {
      pagination: {
        el: '.approachApp__sliderDots',
      },
      navigation: {
        nextEl: '.approachApp__nextSlide',
        prevEl: '.approachApp__previousSlide',
      }
    });

  $('[toggle-button').on('click', function(){
    var targetData = $(this).attr('toggle-button');
    var newTitle = $(this).text()
    $('[data-swapper]').hide();
    $('[data-swapper]').each(function(){
      if (($(this).attr('data-swapper')).includes(targetData)){
        $(this).show();
      }
    });
    $('.newPDPMain__title').text(newTitle);
    //$('[data-swapper="'+targetData+'"]').show();
  });

  var sliderArray = [];
  var swiperCount = 0;
  $('[data-builder-index] .swiper-wrapper').each(function () {
    var thisIndex = $(this).closest('[data-builder-index]').attr('data-builder-index');
    var thisParent = $(this).parent();
    if (thisParent.hasClass('abnbShop__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 24,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        navigation: {
          nextEl: '.abnbShop__nextButton',
          prevEl: '.abnbShop__prevButton',
        },
        loop: false,
        breakpoints: {
          1000: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        pagination: {
          el: '.abnbShop__dotsWrapper',
        }
      };
      sliderArray[swiperCount] = new Swiper(
        '[data-builder-index="' + thisIndex + '"] .abnbShop__sliderWrapper',
        swiperData
      );
      swiperCount++;
    } else if (thisParent.hasClass('abnbSecurity__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: false,
        navigation: {
          nextEl: '.abnbSecurity__nextButton',
          prevEl: '.abnbSecurity__prevButton',
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        pagination: {
          el: '.abnbSecurity__dotsWrapper',
        },
        breakpoints: {
          1000: {
            slidesPerView: 3
          },
        }
      };
      sliderArray[swiperCount] = new Swiper(
        '[data-builder-index="' + thisIndex + '"] .abnbSecurity__sliderWrapper',
        swiperData
      );
      swiperCount++;
    } else if (thisParent.hasClass('abnbMobApp__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: '.abnbMobApp__nextButton',
          prevEl: '.abnbMobApp__prevButton',
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        pagination: {
          el: '.abnbMobApp__dots',
        }
      };
      sliderArray[swiperCount] = new Swiper(
        '[data-builder-index="' + thisIndex + '"] .abnbMobApp__sliderWrapper',
        swiperData
      );
      swiperCount++;
    }else if (thisParent.hasClass('eco3Cards__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: false,
        navigation: {
          nextEl: '[data-builder-index="' + thisIndex + '"] .eco3Card__arrow--next',
          prevEl: '[data-builder-index="' + thisIndex + '"] .eco3Card__arrow--prev',
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        pagination: {
          el: '[data-builder-index="' + thisIndex + '"] .eco3Cards__dotsHolder',
        },
        breakpoints: {
          1000: {
            slidesPerView: 3
          },
        }
      };
      sliderArray[swiperCount] = new Swiper(
        '[data-builder-index="' + thisIndex + '"] .eco3Cards__sliderWrapper',
        swiperData
      );
      swiperCount++;
    }else if (thisParent.hasClass('eco3Col__sliderWrapper')) {
      var swiperData = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        navigation: {
          nextEl: '[data-builder-index="' + thisIndex + '"] .eco3Card__arrow--next',
          prevEl: '[data-builder-index="' + thisIndex + '"] .eco3Card__arrow--prev',
        },
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        pagination: {
          el: '[data-builder-index="' + thisIndex + '"] .eco3Cards__dotsHolder',
        },
        breakpoints: {
          1000: {
            slidesPerView: 3
          },
        }
      };
      sliderArray[swiperCount] = new Swiper(
        '[data-builder-index="' + thisIndex + '"] .eco3Col__sliderWrapper',
        swiperData
      );
      swiperCount++;
    }
  });

  $('.abnbAppButton').each(function(){
    $('<img/>')[0].src = $(this).attr('data-image');
  });

  $('.abnbAppButton').on('click', function(){
    var owner = $(this).closest('.abnbApp');
    if (!$(this).hasClass('abnbAppButton--active')){
      owner.find('.abnbAppButton--active').removeClass('abnbAppButton--active');
      $(this).addClass('abnbAppButton--active');
      var newSrc = $(this).attr('data-image');
      owner.find('.abnbApp__image').attr('src', newSrc);
    }
  });

  $('.abnbProd__colorWrapper--active .abnbProd__color').each(function(){
    var card = $(this).closest('.abnbProd');
    var buyButton = card.find('.abnbProd__buy');
    if ($(this).attr('data-available') == "false"){
      buyButton.find('span').text('Sold Out');
      buyButton.prop("disabled", true);
    }
    else{
      buyButton.find('span').text('Add to Cart');
      buyButton.prop("disabled", false);
    }
  });

  $('.abnbProd__color').each(function(){
    $('<img/>')[0].src = $(this).attr('data-image');
  });

  $('.abnbProd__color').on('click', function(){
    var card = $(this).closest('.abnbProd');
    var imageTarget = card.find('.abnbProd__image');
    var newImage = $(this).attr('data-image');
    var skuTarget = card.find('.abnbProd__sku');
    var newSku = 'SKU: ' + $(this).attr('data-sku');
    var buyButton = card.find('.abnbProd__buy');
    if (!$(this).parent().hasClass('abnbProd__colorWrapper--active')){
      skuTarget.text(newSku);
      imageTarget.attr('src', newImage);
      if ($(this).attr('data-available') == "false"){
        buyButton.find('span').text('Sold Out');
        buyButton.prop("disabled", true);
      }
      else{
        buyButton.find('span').text('Add to Cart');
        buyButton.prop("disabled", false);
      }
      card.find('.abnbProd__colorWrapper--active').removeClass('abnbProd__colorWrapper--active');
      $(this).parent().addClass('abnbProd__colorWrapper--active');
    }
  });

  $('.abnbProd__buy').on('click', function(){
    var card = $(this).closest('.abnbProd');
    var variant = card.find('.abnbProd__colorWrapper--active button').attr('data-id');
    var qty = card.find('.abnbProd__input').val() * 1;
    addSelectedItem(variant, qty);
    openCart('cart');
  });

  $('.abnbProd__accordionHead').on('click', function(){
    var target = $(this).parent().find('.abnbProd__accordionBody');
    $(this).toggleClass('abnbProd__accordionHead--active');
    target.slideToggle();
  });

  $('.abnbFaqBlock__head').on('click', function(){
    var target = $(this).parent().find('.abnbFaqBlock__body');
    $(this).toggleClass('abnbFaqBlock__head--active');
    target.slideToggle();
  });

  $('.abnbProd__qtyLess').on('click', function(){
    var target = $(this).parent().find('input');
    var currentValue = target.val() * 1;
    if (currentValue > 1){
      target.val(currentValue - 1);
    }
  });
  $('.abnbProd__qtyMore').on('click', function(){
    var target = $(this).parent().find('input');
    var currentValue = target.val() * 1;
    target.val(currentValue + 1);
  });

  var firstAbnbSbs = $('.abnbSBS').first();
  $('<div class="abnbSBSMob"><div class="abnbSBSMob__inner"><div class="abnbSBSMob__sliderControls"></div><div class="abnbSBSMob__sliderWrapper"><div class="abnbSBSMob__slider swiper-wrapper"></div></div><div class="abnbSBSMob__dotsWrapper"></div></div></div>').insertBefore(firstAbnbSbs);
  $('.abnbSBSMob__sliderControls').html('<button class="abnbSBSMob__prevArrow"><img class="abnbSBSMob__prevArrowIcon" src="https://cdn.shopify.com/s/files/1/1354/7835/files/Vector_20.png?v=1722888081" alt="previous arrow icon"></button><button class="abnbSBSMob__nextArrow"><img class="abnbSBSMob__nextArrowIcon" src="https://cdn.shopify.com/s/files/1/1354/7835/files/Vector_20_1.png?v=1722888092" alt="next arrow icon"></button>');
  
  const html = (strings, ...values) => String.raw({ raw: strings }, ...values);
  var mobAbnbSlideTemplate = html`<div class="abnbSBSMobSlide swiper-slide">
    <div class="abnbSBSMobSlide__inner">
      <div class="abnbSBSMobSlide__upper">
        <div class="abnbSBSMobSlide__title">
          
        </div>
        <div class="abnbSBSMobSlide__text">
          
        </div>
      </div>
      <div class="abnbSBSMobSlide__lower">
        <div class="abnbSBSMobSlide__imageWrapper">
          <img class="abnbSBSMobSlide__image"
          src=""
          alt="">
        </div>
      </div>
    </div>
  </div>`;

  $('.abnbSBSMob').append(mobAbnbSlideTemplate);
  var template = $('.abnbSBSMobSlide').clone(false);
  $('.abnbSBSMobSlide').remove();

  $('.abnbSBS').each(function(){
    var thisElement = template.clone(false);
    var slideTitle = $(this).find('.abnbSBS__title').text();
    thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
    var slideText = $(this).find('.abnbSBS__text').text();
    thisElement.find('.abnbSBSMobSlide__text').text(slideText);
    var slideSrc = $(this).find('.abnbSBS__image').attr('src');
    var slideAlt = $(this).find('.abnbSBS__image').attr('alt');
    thisElement.find('.abnbSBSMobSlide__image').attr('src', slideSrc);
    thisElement.find('.abnbSBSMobSlide__image').attr('alt', slideAlt);

    $('.abnbSBSMob__slider').append(thisElement);
  });

  var abnbSbsSlider = new Swiper('.abnbSBSMob__sliderWrapper', {
    slidesPerView: 1,
    loop: false,
    navigation: {
      nextEl: '.abnbSBSMob__nextArrow',
      prevEl: '.abnbSBSMob__prevArrow',
    },
    freeMode: {
      enabled: true,
      sticky: true,
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    pagination: {
      el: '.abnbSBSMob__dotsWrapper',
      type: 'bullets'
    }
  });

  var $root = $('html, body');

$('a[href^="#"]:not([onclick])').click(function () {
    $root.animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);

    return false;
});

  $('.featuredDCard [data-product="yale-approach-lock-with-wi-fi-keypad-touch"]').each(function(){
    var parent = $(this).closest('.featuredDCard');
    parent.find('[data-index="2"]').click();
  });
  $('.featuredDCard .featuredDCard__buy').on('click', function(){
    var parent = $(this).closest('.featuredDCard');
    if (parent.find('[data-index="2"]').hasClass('colCard__colorSelect--active')){
      setTimeout(function(){
        $('.newCart__colorButton[newcolor="2"]').click();
      }, 100);
    }
  });

  function displayDiscounts(){
    $('[data-discount-handle]').each(function(){
      var thisHandle = $(this).attr('data-discount-handle');
      var thisHTML = $(this).html();
      var thisPrice = $(this).text();
      var discounted = false;
      for (i=0;i<discountProds.length;i++){
        if (discountProds[i].handle == thisHandle){
          discounted = discountProds[i]["discount_price"];
        }
      }
      if (discounted != false){
        if (thisHTML.indexOf('<strong>')){
          $(this).html('<strong>' + discounted + ' <s class="colCard22__oldPrice">'+thisPrice+'</s></strong>');
        }
        else{
          $(this).html(discounted + ' <s class="colCard22__oldPrice>'+thisPrice+'</s>');
        }
        
      }
    });
  }
  displayDiscounts();

  $('.newPDPMain__productButton').on('click', function(){
    populateNewExtend();
  });

  
  
});